var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStatisticsCredits = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#statistics_credits_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10 2.667A5.33 5.33 0 0 0 4.667 8 5.33 5.33 0 0 0 10 13.334 5.33 5.33 0 0 0 15.333 8 5.33 5.33 0 0 0 10 2.667M10 12c-2.207 0-4-1.793-4-4s1.793-4 4-4 4 1.794 4 4-1.793 4-4 4M2 8c0-1.74 1.113-3.22 2.667-3.766V2.84a5.33 5.33 0 0 0-4 5.16 5.33 5.33 0 0 0 4 5.16v-1.393A3.99 3.99 0 0 1 2 8"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "statistics_credits_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgStatisticsCredits;